import React, { useEffect, useState } from "react";
import { Table, Tooltip, Col, Form, Input, Switch } from "antd";
import HeadingBack from "../component/HeadingBack";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import SvgIcon from "../const/SvgIcon";
import { allapiAction } from "../../Redux/common/action";
import ImageUploading from "react-images-uploading";
import { ExclamationCircleFilled } from "@ant-design/icons";
import { Button, Modal, Space } from "antd";
import { toast } from "react-toastify";
import imageCompression from "browser-image-compression";
import { URL } from "../../Redux/common/url";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import Editor from "ckeditor5-custom-build/build/ckeditor";

function News() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [page, setPage] = useState(1);

  const users_list = useSelector((state) =>
    state?.allapi?.get_blog ? state?.allapi?.get_blog : {}
  );

  console.log(users_list);

  const listdata = users_list?.docs ? users_list?.docs : [];

  const dataSource = [
    {
      key: "1",
      name: "Mike",
      age: 32,
      address: "10 Downing Street",
    },
    {
      key: "2",
      name: "John",
      age: 42,
      address: "10 Downing Street",
    },
  ];

  const [showDelelt, setShowDelete] = useState(false);

  const handleCloseDelete = () => setShowDelete(false);
  const [cateID, setcateID] = useState("");

  const hendleDelete = (e) => {
    console.log(e);
    // deleteProduct
    setShowDelete(false);
    dispatch(allapiAction.deleteNews({ id: e, page: page }));
    // dispatch(adminAction.getRoleList('dhsg'))
    return () => {};
  };

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [addModalOpen, setAddModalOpen] = useState(false);

  const hendleModalShow = (e) => {
    // setShowDelete(true)
    setcateID(e);
    setIsModalOpen(true);
  };

  const [cateDetail, setcateDetail] = useState({});

  console.log(cateDetail);

  const [images, setImages] = useState([]);
  const maxNumber = 1;

  console.log(images);

  const [Imagesfe, setImagesfe] = useState("");
  // const onChangefe = (imageList, addUpdateIndex) => {
  //   // data for submit
  //   // console.log(imageList, addUpdateIndex)
  //   setImagesfe(imageList);
  // };
  const onChangefe = async (imageList, addUpdateIndex) => {
    // data for submit
    // console.log(imageList, addUpdateIndex)
    if (imageList.length > 0) {
      const options = {
        maxSizeMB: 1, // Max 1MB
        maxWidthOrHeight: 800, // Max width/height
        useWebWorker: true, // Faster processing
      };
      const compressedFile = await imageCompression(
        imageList[0]?.file,
        options
      );
      imageList[0].newfile = compressedFile;
    }
    setImagesfe(imageList);
  };

  const onChange = (imageList, addUpdateIndex) => {
    // data for submit
    console.log(imageList, addUpdateIndex);
    setImages(imageList);
  };

  const hendleTochangeCategory = (e) => {
    const { name, value } = e.target;
    setcateDetail({ ...cateDetail, [name]: value });
  };
  const [aboutPageUpdate, setaboutPageUpdate] = useState("");
  const showModal = (e) => {
    console.log(e);
    setcateDetail(e);
    setaboutPageUpdate(e?.description);

    setImagesfe([{ data_url: URL.API_BASE_URL + e.feature_image }]);
    setIsModalOpen(true);
  };
  const handleOk = () => {
    const data = new FormData();
    data.append("title", cateDetail?.title);
    data.append("description", aboutPageUpdate);
    data.append("meta_description", cateDetail?.meta_description);
    data.append("short_description", cateDetail?.short_description);
    data.append("meta_title", cateDetail?.meta_title);
    // data.append("meta_description", cateDetail?.meta_description);
    data.append("_id", cateDetail?._id);
    data.append("page", page);
    if (Imagesfe[0]?.file) {
      // roledata?.role_name
      data.append(
        "feature_image",
        Imagesfe[0]?.newfile,
        Imagesfe[0]?.file?.name
      );
      // data.append("feature_image", Imagesfe[0]?.file);
    }
    dispatch(allapiAction.updateNews(data));
    // dispatch(adminAction.getRoleList('dhsg'))
    setIsModalOpen(false);
    return () => {};
  };
  const hendleToSubmit = (item, status, type) => {
    const data = new FormData();

    data.append("_id", cateDetail?._id);
    data.append("page", page);

    dispatch(
      allapiAction.updateNewStatus({ _id: item?._id, page, status, type })
    );
    // dispatch(adminAction.getRoleList('dhsg'))
    // setIsModalOpen(false);
    return () => {};
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const [cateDetailAdd, setcateDetailAdd] = useState({});
  console.log(cateDetailAdd);

  const hendleTochangeCategoryAdd = (e) => {
    const { name, value } = e.target;
    setcateDetailAdd({ ...cateDetailAdd, [name]: value });
  };

  const showModalAdd = (e) => {
    console.log(e);
    setcateDetail(e);
    setAddModalOpen(true);
  };

  const [aboutPage, setaboutPage] = useState("");
  const handleOkAdd = () => {
    if (!cateDetailAdd?.title) {
      toast.error("please enter title");
    } else {
      const data = new FormData();
      data.append("page", 1);
      data.append("title", cateDetailAdd?.title);
      data.append("description", aboutPage);
      data.append("meta_title", cateDetailAdd?.meta_title);
      data.append("meta_description", cateDetailAdd?.meta_description);
      data.append("short_description", cateDetailAdd?.short_description);
      //   data.append("meta_description", cateDetailAdd?.meta_description);
      // data.append('categoryName', 'test cate')
      //   data.append("parentId", "11");
      //   data.append("sellerId", "20");
      data.append("feature_image", images[0]?.file);

      dispatch(allapiAction.createBlogs(data));

      setcateDetailAdd({ name: "", link: "" });
      // dispatch(adminAction.getRoleList('dhsg'))
      setAddModalOpen(false);
      return () => {};
    }
  };

  const handleCancelAdd = () => {
    setAddModalOpen(false);
  };

  const { confirm } = Modal;

  const showDeleteConfirm = (e) => {
    confirm({
      title: "Are you sure delete ?",
      icon: <ExclamationCircleFilled />,
      content: "Some descriptions",
      okText: "Yes",
      okType: "danger",
      cancelText: "No",
      onOk() {
        hendleDelete(e);
        console.log("OK");
      },
      onCancel() {
        console.log("Cancel");
      },
    });
  };

  const hendleToStatus = (id, e) => {
    // statusCategory

    // dispatch(allapiAction.statusBrands({ productId: id, status: e }));
    // dispatch(adminAction.getRoleList('dhsg'))
    return () => {};
  };

  const columns = [
    {
      title: "S.No.",
      dataIndex: "sno",
      key: "sno",
      className: "table_first_col",
      render: (value, item, index) => (page - 1) * 10 + index + 1,
    },
    {
      title: "Image",
      dataIndex: "image",
      key: "image",
      className: "table_action_col",
      render: (value, item, index) => {
        return (
          <>
            <div style={{ width: "100px" }}>
              <img
                style={{ width: "100%" }}
                src={URL?.API_BASE_URL + item?.feature_image}
                alt=""
              />
            </div>
          </>
        );
      },
    },
    {
      title: "Title",
      dataIndex: "title",
      key: "title",
    },
    {
      title: "Total View",
      dataIndex: "totalView",
      key: "totalView",
    },
    {
      title: "Extra View",
      dataIndex: "extraView",
      key: "extraView",
    },
    {
      title: "Short description",
      dataIndex: "short_description",
      key: "short_description",
    },
    // {
    //   title: "Email",
    //   dataIndex: "email",
    //   key: "email",
    // },

    // {
    //   title: "Status",
    //   dataIndex: "status",
    //   key: "status",
    //   className: "table_action_col",
    //   render: (value, item, index) => {
    //     return (
    //       <>
    //         <Tooltip title={item?.status}>
    //           <button
    //             className={
    //               item?.is_status == "Active"
    //                 ? "success-button ml-3"
    //                 : "delete-button ml-3"
    //             }
    //             onClick={() =>
    //               hendleToStatus(
    //                 item?._id,
    //                 item?.is_status == "Active" ? "Inactive" : "Active"
    //               )
    //             }
    //           >
    //             {item?.is_status}
    //           </button>
    //         </Tooltip>
    //       </>
    //     );
    //   },
    // },
    {
      title: "Publish",
      dataIndex: "action",
      key: "action",
      className: "table_action_col",
      render: (value, item, index) => {
        return (
          <>
            <Tooltip title={item?.publish == "Yes" ? "Publish" : "Unpublish"}>
              <div className="flex items-center gap-3">
                {/* <span className="text-sm font-medium">Amenity Active:</span> */}
                <Switch
                  checked={item?.publish == "Yes" ? true : false}
                  onChange={(e) =>
                    hendleToSubmit(
                      item,
                      item?.publish == "Yes" ? "No" : "Yes",
                      "publish"
                    )
                  }
                />
                {/* <span className="text-gray-500 text-sm">
                  {item?.publish == "Yes" ? "Publish" : "Unpublish"}
                </span> */}
              </div>
            </Tooltip>
          </>
        );
      },
    },
    {
      title: "Braking",
      dataIndex: "action",
      key: "action",
      className: "table_action_col",
      render: (value, item, index) => {
        return (
          <>
            <Tooltip title={item?.braking == "Yes" ? "Publish" : "Unpublish"}>
              <div className="flex items-center gap-3">
                {/* <span className="text-sm font-medium">Amenity Active:</span> */}
                <Switch
                  checked={item?.braking == "Yes" ? true : false}
                  onChange={(e) =>
                    hendleToSubmit(
                      item,
                      item?.braking == "Yes" ? "No" : "Yes",
                      "braking"
                    )
                  }
                  //   onChange={(checked) => setEnabled(checked)}
                />
                {/* <span className="text-gray-500 text-sm">
                  {item?.publish == "Yes" ? "Publish" : "Unpublish"}
                </span> */}
              </div>
            </Tooltip>
          </>
        );
      },
    },
    {
      title: "Tranding",
      dataIndex: "action",
      key: "action",
      className: "table_action_col",
      render: (value, item, index) => {
        return (
          <>
            <Tooltip title={item?.tranding == "Yes" ? "Publish" : "Unpublish"}>
              <div className="flex items-center gap-3">
                {/* <span className="text-sm font-medium">Amenity Active:</span> */}
                <Switch
                  checked={item?.tranding == "Yes" ? true : false}
                  onChange={(e) =>
                    hendleToSubmit(
                      item,
                      item?.tranding == "Yes" ? "No" : "Yes",
                      "tranding"
                    )
                  }
                  //   onChange={(checked) => setEnabled(checked)}
                />
                {/* <span className="text-gray-500 text-sm">
                  {item?.publish == "Yes" ? "Publish" : "Unpublish"}
                </span> */}
              </div>
            </Tooltip>
          </>
        );
      },
    },
    {
      title: "Actions",
      dataIndex: "action",
      key: "action",
      className: "table_action_col",
      render: (value, item, index) => {
        return (
          <>
            <Tooltip title="Edit">
              <span
                className="cursor-pointer"
                onClick={() => {
                  showModal(item);
                }}
              >
                <SvgIcon.Edit className="scale-icon edit-icon" />
              </span>
            </Tooltip>
            {/* <Tooltip title="Delete">
              <span
                className="cursor-pointer"
                onClick={() => {
                                hendleModalShow(item?.id)
                              }}
              >
                <SvgIcon.deletebtn className="scale-icon edit-icon" />
              </span>
            </Tooltip> */}
            <Tooltip title="Delete">
              <span
                className="cursor-pointer"
                onClick={() => {
                  showDeleteConfirm(item?._id);
                }}
              >
                <SvgIcon.deletebtn className="scale-icon edit-icon" />
              </span>
            </Tooltip>
          </>
        );
      },
    },
  ];

  useEffect(() => {
    dispatch(allapiAction.getNewsList(1));

    return () => {};
  }, []);

  // const [page, setPage] = useState(1);
  const [search, setsearch] = useState("");
  const handleChange = (e) => {
    console.log(e);
    setsearch(e);
    setPage(1);
    if (e) {
      dispatch(allapiAction.allcategorySearch({ page: 1, search: e }));
      return () => {};
    } else {
      dispatch(allapiAction.getNewsList(1));

      return () => {};
    }
    // getuserListSearch
    // &user_id=${data?.user_id}&search=${data?.user_id}
  };

  const hendlePahegi = (e) => {
    setPage(e);
    if (search) {
      dispatch(allapiAction.allcategorySearch({ page: e, search: search }));
      return () => {};
    } else {
      dispatch(allapiAction.getNewsList(e));

      return () => {};
    }
  };

  const API_URl = URL.API_BASE_URL;
  const UPLOAD_ENDPOINT = "publicApi/productcon";

  function uploadAdapter(loader) {
    return {
      upload: () => {
        return new Promise((resolve, reject) => {
          const body = new FormData();
          loader.file.then((file) => {
            body.append("upload", file);
            fetch(`${API_URl}/${UPLOAD_ENDPOINT}`, {
              method: "post",
              body: body,
            })
              .then((res) => res.json())
              .then((res) => {
                // console.log(res);
                resolve({ default: `${res.url}` });
              })
              .catch((err) => {
                reject(err);
              });
          });
        });
      },
    };
  }
  function uploadPlugin(editor) {
    editor.plugins.get("FileRepository").createUploadAdapter = (loader) => {
      return uploadAdapter(loader);
    };
  }
  return (
    <div>
      {/* update */}
      <Modal
        title="Update Blog"
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
      >
        <Col lg={24} md={24} sm={24} xs={24}>
          <ImageUploading
            // multiple
            value={Imagesfe}
            onChange={onChangefe}
            maxNumber={maxNumber}
            dataURLKey="data_url"
            acceptType={["png", "jpeg", "jpg", "webp"]}
            // acceptType={['jpg']}
          >
            {({
              imageList,
              onImageUpload,
              onImageRemoveAll,
              onImageUpdate,
              onImageRemove,
              isDragging,
              dragProps,
            }) => (
              // write your building UI
              <div className="upload__image-wrapper">
                <button
                  style={isDragging ? { color: "red" } : {}}
                  onClick={onImageUpload}
                  {...dragProps}
                  className="btn btn-secondary"
                >
                  Choose image
                </button>
                &nbsp;
                <button
                  className="btn btn-secondary"
                  onClick={onImageRemoveAll}
                >
                  Remove all images
                </button>
                {imageList.map((image, index) => (
                  <div key={index} className="image-item">
                    <img src={image.data_url} alt="" width="100" />
                    <div className="image-item__btn-wrapper">
                      <button
                        className="btn btn-secondary"
                        onClick={() => onImageUpdate(index)}
                      >
                        Update
                      </button>
                      <button
                        className="btn btn-secondary"
                        onClick={() => onImageRemove(index)}
                      >
                        Remove
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </ImageUploading>
        </Col>
        <Col lg={24} md={24} sm={24} xs={24}>
          <input
            autoComplete="new-off"
            className="form-control mt-8"
            placeholder="name"
            name="title"
            value={cateDetail?.title}
            onChange={(e) => {
              hendleTochangeCategory(e);
            }}
          />
        </Col>
        <Col lg={24} md={24} sm={24} xs={24}>
          <input
            autoComplete="new-off"
            className="form-control mt-8"
            placeholder="short description"
            name="short_description"
            value={cateDetail?.short_description}
            onChange={(e) => {
              hendleTochangeCategory(e);
            }}
          />
        </Col>
        <Col lg={24} md={24} sm={24} xs={24}>
          <input
            autoComplete="new-off"
            className="form-control mt-8"
            placeholder="meta title"
            name="meta_title"
            value={cateDetail?.meta_title}
            onChange={(e) => {
              hendleTochangeCategory(e);
            }}
          />
        </Col>
        <Col lg={24} md={24} sm={24} xs={24}>
          <input
            autoComplete="new-off"
            className="form-control mt-8"
            placeholder="meta description"
            name="meta_description"
            value={cateDetail?.meta_description}
            onChange={(e) => {
              hendleTochangeCategory(e);
            }}
          />
        </Col>
        <Col lg={24} md={24} sm={24} xs={24}>
          <CKEditor
            editor={Editor}
            data={aboutPageUpdate}
            onReady={(editor) => {
              // console.log('SDfsf')
              // console.log(editor)
            }}
            onChange={(event, editor) => {
              // console.log(editor)
              const data = editor.getData();
              setaboutPageUpdate(data);
            }}
            config={{
              extraPlugins: [uploadPlugin],
            }}
            onBlur={(event, editor) => {
              console.log("SDfsf");
            }}
            onFocus={(event, editor) => {
              console.log("SDfsf");
            }}
          />
        </Col>
        {/* <Col lg={24} md={24} sm={24} xs={24}>
          <input
            autoComplete="new-off"
            className="form-control mt-8"
            placeholder="meta description"
            name="meta_description"
            value={cateDetail?.meta_description}
            onChange={(e) => {
              hendleTochangeCategory(e);
            }}
          />
        </Col> */}
      </Modal>

      {/* create */}
      <Modal
        title="Create Blog"
        open={addModalOpen}
        onOk={handleOkAdd}
        onCancel={handleCancelAdd}
      >
        <Col lg={24} md={24} sm={24} xs={24}>
          <ImageUploading
            // multiple
            value={images}
            onChange={onChange}
            maxNumber={maxNumber}
            dataURLKey="data_url"
            acceptType={["png", "jpeg", "jpg", "webp"]}
            // acceptType={['jpg']}
          >
            {({
              imageList,
              onImageUpload,
              onImageRemoveAll,
              onImageUpdate,
              onImageRemove,
              isDragging,
              dragProps,
            }) => (
              // write your building UI
              <div className="upload__image-wrapper">
                <button
                  style={isDragging ? { color: "red" } : {}}
                  onClick={onImageUpload}
                  {...dragProps}
                  className="btn btn-secondary"
                >
                  Choose image
                </button>
                &nbsp;
                <button
                  className="btn btn-secondary"
                  onClick={onImageRemoveAll}
                >
                  Remove all images
                </button>
                {imageList.map((image, index) => (
                  <div key={index} className="image-item">
                    <img src={image.data_url} alt="" width="100" />
                    <div className="image-item__btn-wrapper">
                      <button
                        className="btn btn-secondary"
                        onClick={() => onImageUpdate(index)}
                      >
                        Update
                      </button>
                      <button
                        className="btn btn-secondary"
                        onClick={() => onImageRemove(index)}
                      >
                        Remove
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </ImageUploading>
        </Col>
        <Col lg={24} md={24} sm={24} xs={24}>
          <input
            autoComplete="new-off"
            className="form-control mt-8"
            placeholder="Title"
            name="title"
            value={cateDetailAdd?.title}
            onChange={(e) => {
              hendleTochangeCategoryAdd(e);
            }}
          />
        </Col>

        <Col lg={24} md={24} sm={24} xs={24}>
          <input
            autoComplete="new-off"
            className="form-control mt-8"
            placeholder="short description"
            name="short_description"
            value={cateDetailAdd?.short_description}
            onChange={(e) => {
              hendleTochangeCategoryAdd(e);
            }}
          />
        </Col>
        <Col lg={24} md={24} sm={24} xs={24}>
          <input
            autoComplete="new-off"
            className="form-control mt-8"
            placeholder="meta title"
            name="meta_title"
            value={cateDetailAdd?.meta_title}
            onChange={(e) => {
              hendleTochangeCategoryAdd(e);
            }}
          />
        </Col>
        <Col lg={24} md={24} sm={24} xs={24}>
          <input
            autoComplete="new-off"
            className="form-control mt-8"
            placeholder="meta description"
            name="meta_description"
            value={cateDetailAdd?.meta_description}
            onChange={(e) => {
              hendleTochangeCategoryAdd(e);
            }}
          />
        </Col>
        <Col lg={24} md={24} sm={24} xs={24}>
          <CKEditor
            editor={Editor}
            data={aboutPage}
            onReady={(editor) => {
              // console.log('SDfsf')
              // console.log(editor)
            }}
            onChange={(event, editor) => {
              // console.log(editor)
              const data = editor.getData();
              setaboutPage(data);
            }}
            config={{
              extraPlugins: [uploadPlugin],
            }}
            onBlur={(event, editor) => {
              console.log("SDfsf");
            }}
            onFocus={(event, editor) => {
              console.log("SDfsf");
            }}
          />
        </Col>
      </Modal>

      <div className="flex">
        <div>
          <HeadingBack
            title={"News"}
            subHeading={`Total ${users_list?.totalDocs || 0} News`}
          />
        </div>
        <Col md={5} sm={5} xs={12} className="pl-5  ml-5">
          {/* <Input
            type="text"
            autoComplete="new-off"
            className="form-control"
            onChange={(e) => handleChange(e.target.value)}
            placeholder="Search..."
            // value={values?.TestCode}
          /> */}
          {/* <AsyncPaginate
            // key={managerKey}
            value={seleceteManger}
            loadOptions={loadOptionsgetManager}
            onChange={setseleceteManger}
            additional={{
              page: 1,
            }}
          /> */}
        </Col>

        <div className="flex1 flex justify-content-end align-items-center">
          <Tooltip title="Add">
            <span className="jop_btn" onClick={() => navigate("/add-news")}>
              Add
              <SvgIcon.Add width={40} height={40} className="cursor-pointer" />
            </span>
          </Tooltip>
        </div>
      </div>

      <div className="tableResponsive mt-10">
        <Table
          dataSource={listdata}
          columns={columns}
          className={"table antd_table"}
          pagination={{
            current: page,
            pageSize: 10,
            onChange(current, pageSize) {
              hendlePahegi(current);
            },
            hideOnSinglePage: true,
            total: users_list?.totalDocs ? users_list?.totalDocs : 0,
          }}
        />
      </div>
    </div>
  );
}

export default News;
